export const TIPO_OPERAZIONE_PRENOTAZIONE_SERVIZI = 'op_prenotazione_servizi';
export const TIPO_OPERAZIONE_PRENOTAZIONE_GRUPPI = 'op_prenotazione_gruppi';
export const TIPO_OPERAZIONE_PRENOTAZIONE_POSTI = 'op_prenotazione_posti';
export const TIPO_OPERAZIONE_ORDINE_FOOD = 'op_ordine_food';
export const TIPO_OPERAZIONE_ORDINE_ECOMMERCE = 'op_ordine_ecommerce';
export const TIPO_OPERAZIONE_PRENOTAZIONE_CAMERA = 'op_prenotazione_camera';
export const TIPO_OPERAZIONE_RICARICA_NEGOZIO = 'op_ricarica_negozio';
export const TIPO_OPERAZIONE_RIMBORSO_NEGOZIO = 'op_rimborso_negozio';
export const TIPO_OPERAZIONE_SCARICO_NEGOZIO = 'op_scarico_negozio';
export const TIPO_OPERAZIONE_ACQUISTO_GIFTCARD = 'op_acquisto_giftcard';